import { graphql } from 'gatsby'
import DownloadApp from '../views/downloadApp'

export default DownloadApp
export const query = graphql`
  query DownloadAppPageQuery($slug: String, $locale: String) {
    hero: contentfulHeroSection(
      page: { elemMatch: { node_locale: { eq: $locale }, slug: { eq: $slug } } }
    ) {
      ...heroFragment
    }
    ctaSection: contentfulCtaSection(
      page: { elemMatch: { node_locale: { eq: $locale }, slug: { eq: $slug } } }
    ) {
      downloadAppstoreUrl
      downloadPlaystoreUrl
      downloadAppGalleryUrl
    }
    page: contentfulPage(slug: { eq: $slug }, node_locale: { eq: $locale }) {
      metaDescription
      metaTag
      title
      slug
    }
  }
`
